// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__wyrRXwZV4F2u-","dropdown":"dropdown__9t3-kFlt31vRc","delete":"delete__m95q8S5tugQ+W"};